import { useMemo } from 'react';

import {
  completedScanIqCustomerListStore,
  needSetupScanIqCustomerListStore,
  ScanIqCustomersListStore,
} from '../../../stores/scanIqCustomersListStore';
import {
  SETUP_STATUS,
  SetupStatusTab,
} from '../../../interfaces/ScanIqCustomerSetupInfo';

export const useScanIqCustomerListStore = (
  setupStatus: SetupStatusTab,
): ScanIqCustomersListStore => {
  const stores: Record<SetupStatusTab, ScanIqCustomersListStore> = {
    [SETUP_STATUS.COMPLETED]: completedScanIqCustomerListStore,
    [SETUP_STATUS.NEED_SETUP]: needSetupScanIqCustomerListStore,
  };

  return useMemo(() => {
    return stores[setupStatus];
  }, [setupStatus]);
};
